export default __webpack_public_path__ + "assets/right_mobile.1fac421e.png";